export const audit = {
  description: "من فعل ماذا ومتى. يربط معرّف الطلب كل حدثٍ بسطر السجل المطابق في الخادم.",
  filterByAction: "تصفية حسب الإجراء",
  filter: {
    allActions: "كل الإجراءات",
  },
  caption: "أحداث سجل التدقيق",
  emptyTitle: "لا توجد أحداث مطابقة",
  emptyDescription: "جرّب السجل الكامل مرة أخرى أو امسح التصفية.",
  column: {
    action: "الإجراء",
    record: "السجل",
    actor: "الفاعل",
    requestId: "معرّف الطلب",
  },
  system: "النظام",
  action: {
    signIn: "تسجيل الدخول",
    signInFailed: "تسجيل دخول فاشل",
    signOut: "تسجيل الخروج",
    userCreated: "تم إنشاء مستخدم",
    roleChanged: "تم تغيير الدور",
    userActivated: "تم تفعيل مستخدم",
    userDeactivated: "تم إيقاف تفعيل مستخدم",
    documentUploaded: "تم رفع مستند",
    documentDownloaded: "تم تنزيل مستند",
    documentDeleted: "تم حذف مستند",
  },
};
